import { validate } from '@konfirm/iso13616'
import { RuleObject } from 'rc-field-form/lib/interface'
import { ValidationI18n } from './Validate'

const ibanLengthByCountry: Record<string, number> = {
  AD: 24,
  AE: 23,
  AL: 28,
  AT: 20,
  BA: 20,
  BE: 16,
  BG: 22,
  CH: 21,
  CY: 28,
  CZ: 24,
  DE: 22,
  DK: 18,
  EE: 20,
  ES: 24,
  FI: 18,
  FO: 18,
  FR: 27,
  GB: 22,
  GE: 22,
  GI: 23,
  GL: 18,
  GR: 27,
  HR: 21,
  HU: 28,
  IE: 22,
  IL: 23,
  IS: 26,
  IT: 27,
  LI: 21,
  LT: 20,
  LU: 20,
  LV: 21,
  MC: 27,
  MD: 24,
  ME: 22,
  MK: 19,
  MT: 31,
  NL: 18,
  NO: 15,
  PL: 28,
  PT: 25,
  RO: 24,
  RS: 22,
  SA: 24,
  SE: 24,
  SI: 19,
  SK: 24,
  SM: 27,
  TR: 26,
  UA: 29,
  VA: 22,
  XK: 20,
}

export const ibanValidator =
  (i18n: ValidationI18n) => async (_: RuleObject, value: string) => {
    if (!value) {
      return
    }
    if (!value.match(/^[A-Z]{2}/i)) {
      throw new Error(
        i18n._({ key: 'frontend:validation.iban.mustStartWithLetters' })
      )
    }

    const normalized = value.replace(/\s/g, '').toUpperCase()
    const country = normalized.slice(0, 2)
    const expectedLength = ibanLengthByCountry[country]

    if (expectedLength && normalized.length !== expectedLength) {
      throw new Error(
        i18n._({
          key: 'frontend:validation.iban.wrongLength',
          params: { 0: country, 1: expectedLength, 2: normalized.length },
        })
      )
    }

    if (!validate(normalized)) {
      throw new Error(i18n._({ key: 'frontend:validation.iban.invalid' }))
    }
  }
